// src/components/features/timetables/SearchResult/TimetableSearchResult.tsx
import type { ComponentProps } from 'preact';
import { LineRoundel } from '../../../base/LineRoundel/LineRoundel';
import { DisruptionAlert } from '../../../base/DisruptionAlert/DisruptionAlert';
import { Card } from '../../../base/Card/Card';
import type { TimetableLineItem } from '../../../../data/useTimetableSearch';
import styles from './TimetableSearchResult.module.css';

export interface TimetableSearchResultProps extends Omit<
  ComponentProps<'li'>,
  'children'
> {
  line: TimetableLineItem;
  onSelectLine?: (line: TimetableLineItem) => void;
}

/**
 * Represents a single timetable search result option.
 *
 * Intended for line roundel and summary information.
 */
export function TimetableSearchResult({
  line,
  onSelectLine,
  ...props
}: TimetableSearchResultProps) {
  return (
    <li data-component="Timetable Search Result Item" {...props}>
      <button
        className={styles.button}
        type="button"
        onClick={() => onSelectLine?.(line)}
        aria-label={`View timetable for service ${line.name}`}
      >
        <Card>
          <div className={styles.lineRoundelContainer}>
            <LineRoundel
              line={{ name: line.name, colors: line.colors }}
              variant="largeLink"
            />
          </div>
          <div className={styles.description}>
            <span className={styles.title}>
              {line.description || line.title || line.name}
            </span>
            {line.via && <span className={styles.meta}>via {line.via}</span>}
            {line.operatorName && (
              <span className={styles.meta}>{line.operatorName}</span>
            )}
          </div>
          <div className={styles.disruptionBleed}>
            <DisruptionAlert disruption={line.disruption} />
          </div>
        </Card>
      </button>
    </li>
  );
}
